export const sample1 = `<Text pr={1} color="accent">Text1</Text>
<Text<Theme> pr={1} fontStyle="mono" italic>Text2</Text>
<Text pr={1} style={{fontStyle: 'oblique'}}>Text3</Text>
<Text pr={1} uppercase underline>Text4</Text>
`
